{
  "pages": {
    "leads": {
      "title": "Prospects"
    },
    "leadDetail": {
      "title": "Prospect",
      "titleWithId": "Prospect n°{{id}}",
      "description": "{{status}} · {{source}} · Score {{score}}",
      "loadingDescription": "Prospect 360",
      "summary": "Résumé du prospect",
      "communications": "Communications",
      "activities": "Activités",
      "quotations": "Devis"
    },
    "deals": {
      "title": "Affaires",
      "pipelineBoard": "Tableau du pipeline",
      "loadingKanban": "Chargement du kanban…",
      "noCustomer": "Aucun client",
      "noPipelineStages": "Aucune étape de pipeline configurée.",
      "allDeals": "Toutes les affaires",
      "createDeal": "Créer une affaire"
    },
    "tasks": {
      "title": "Tâches"
    },
    "followups": {
      "title": "Suivis",
      "description": "Calls, meetings, reminders et next actions"
    },
    "campaigns": {
      "title": "Campagnes CRM"
    },
    "contacts": {
      "title": "Contacts",
      "editContact": "Modifier le contact",
      "createContact": "Créer un contact",
      "possibleDuplicates": "Doublons possibles"
    },
    "companies": {
      "title": "Sociétés"
    },
    "reports": {
      "title": "Rapports CRM"
    },
    "setup": {
      "title": "Configuration CRM"
    },
    "customers": {
      "title": "Client 360",
      "description": "Client 360 — chronologie Fattah unifiée",
      "loading": "Chargement du profil client…"
    },
    "dashboard": {
      "title": "Tableau de bord CRM",
      "description": "Pipeline, prospects et revenus — filtrés selon votre périmètre de visibilité",
      "pipelineDetails": "Détails du pipeline",
      "openDeals": "Affaires ouvertes",
      "forecastRevenue": "Revenus prévisionnels",
      "wonRevenue": "Revenus gagnés",
      "conversionRate": "Taux de conversion",
      "activitiesDue": "Activités à faire",
      "totalLeads": "Total prospects"
    },
    "segmentedOutreachWithEmailSmsAnd": "Segmented outreach avec email, SMS, et WhatsApp channels",
    "b2bAccountsWithContactsDealsAnd": "B2B accounts avec contacts, deals, et activities",
    "organizationWideCustomerContactsLinkedTo": "Organization-wide client contacts linked à Client 360",
    "pipelineKanbanAndDealListWith": "Pipeline kanban et deal list avec finance quote integration",
    "createLead": "Créer un prospect",
    "convertLeadWithId": "Convertir le prospect n°{{id}}",
    "manageLeadIntakeQualificationAndConversion": "Manage lead intake, qualification et conversion",
    "noLeadsYet": "Aucun prospect pour le moment",
    "captureLeadsFromCampaignsOrAdd": "Capture leads de campaigns ou ajouter them manually à start votre pipeline.",
    "pipelineConversionLeadSourceAndSalesperson": "Pipeline, conversion, lead source, et salesperson performance",
    "pipelines": "Pipelines",
    "scoringRules": "Règles de scoring",
    "assignmentRules": "Règles d'affectation",
    "workflowAutomations": "Flux de travail automations",
    "emailAccountsImapSync": "Comptes e-mail (synchronisation IMAP)",
    "pipelinesScoringAssignmentWorkflowsLeadSources": "Pipelines, scoring, assignment, flux de travails, lead sources, territories, email sync",
    "openCrmTasksAndFollowUps": "Open CRM tasks et follow-ups pour votre team"
  },
  "common": {
    "yes": "Oui",
    "no": "Non",
    "unknownSource": "Source inconnue"
  },
  "toast": {
    "leadCreated": "Prospect créé",
    "leadConverted": "Prospect converti — affaire créée",
    "campaignCreated": "Campagne créée",
    "campaignLaunched": "Campagne lancée",
    "campaignScheduled": "Campagne planifiée",
    "taskCreated": "Tâche créée",
    "taskCompleted": "Tâche terminée",
    "quoteCreated": "Devis créé (facture n°{{invoiceId}})",
    "leadsImported": "{{successCount}} prospects importés",
    "leadsImportedWithFailures": "{{successCount}} prospects importés, {{failureCount}} en échec",
    "emailSynced": "{{count}} nouvelles activités e-mail synchronisées",
    "gmailConnected": "Gmail connecté via XOAUTH2 : {{email}}"
  },
  "errors": {
    "leadCreationFailed": "Échec de la création du prospect",
    "leadConversionFailed": "Échec de la conversion du prospect",
    "loadPipelineFailed": "Échec du chargement du pipeline",
    "moveDealFailed": "Échec du déplacement de l'affaire",
    "createQuoteFailed": "Échec de la création du devis",
    "loadCustomer360Failed": "Échec du chargement du Client 360",
    "createCampaignFailed": "Échec de la création de la campagne",
    "launchFailed": "Échec du lancement",
    "scheduleDateRequired": "Choisissez d'abord une date/heure de planification",
    "scheduleFailed": "Échec de la planification",
    "createFailed": "Échec de la création",
    "reportsUnavailable": "Rapports indisponibles",
    "loadSetupFailed": "Échec du chargement de la configuration",
    "connectEmailFailed": "Échec de la connexion du compte e-mail",
    "emailSyncFailed": "Échec de la synchronisation e-mail",
    "setupFailed": "Échec de la configuration",
    "googleOAuthNotConfigured": "Google OAuth non configuré",
    "loadTasksFailed": "Échec du chargement des tâches",
    "createTaskFailed": "Échec de la création de la tâche",
    "completeTaskFailed": "Échec de la finalisation de la tâche",
    "googleOAuthFailed": "Échec Google OAuth : {{error}}",
    "oauthConnectFailed": "Échec de la connexion OAuth",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToLoadCompanies": "Échec du chargement de companies",
    "failedToLoadContacts": "Échec du chargement de contacts",
    "failedToLoadDeals": "Échec du chargement de deals",
    "failedToLoadCrmLeads": "Échec du chargement de cRM leads",
    "deleteFailed": "Échec de la suppression",
    "duplicateCheckFailed": "Échec de la vérification des doublons",
    "mergeFailed": "Échec de la fusion",
    "leadImportFailed": "Échec de l'import des prospects",
    "activityCreationFailed": "Échec de la création de l'activité",
    "documentCreationFailed": "Échec de la création du document",
    "communicationRecordingFailed": "Échec de l'enregistrement de la communication",
    "failedToScheduleReport": "Échec de la planification du rapport"
  },
  "oauth": {
    "connecting": "Connexion du compte Gmail…"
  },
  "labels": {
    "campaignName": "Nom de la campagne",
    "crm": "CRM",
    "channel": "Canal",
    "audienceSegment": "Segment d'audience",
    "segment": "Segment",
    "scheduled": "Planifié",
    "scheduleTimeForRowActionsBelow": "Heure de planification (pour les actions de ligne ci-dessous)",
    "searchContacts": "Rechercher des contacts",
    "searchNameOrEmail": "Search name ou email",
    "leadSource": "Source du prospect",
    "leadStatus": "Statut du prospect",
    "leadScore": "Score du prospect",
    "leadNumber": "Prospect n°",
    "leadWithId": "Prospect n°{{id}}",
    "customerWithId": "Client n°{{id}}",
    "dealWithId": "Affaire n°{{id}}",
    "source": "Origine",
    "score": "Score",
    "converted": "Converti",
    "dealName": "Nom de l'affaire",
    "deal": "Affaire",
    "expectedRevenue": "Revenu attendu",
    "revenue": "Revenu",
    "probability": "Probabilité",
    "proposal": "Proposition",
    "forecast": "Prévision",
    "products": "Produits",
    "finance": "Finances",
    "invoiceWithId": "Facture n°{{id}}",
    "customer": "Client",
    "customerId": "ID client",
    "companyId": "ID société",
    "expectedCloseDate": "Date de clôture prévue",
    "proposalStatus": "Statut de la proposition",
    "forecastCategory": "Catégorie de prévision",
    "productService": "Produit/service",
    "productAmount": "Montant du produit",
    "budgetConfirmed": "Budget confirmé",
    "decisionMakerNotes": "Notes du décideur",
    "customerName": "Client name",
    "customerEmail": "Client email",
    "email": "Email",
    "imapHost": "Hôte IMAP",
    "imapPort": "Port IMAP",
    "imapUsername": "IMAP utiliserrname",
    "imapPassword": "Mot de passe IMAP",
    "imapPort993": "Port IMAP (993)",
    "newTask": "Nouvelle tâche",
    "name": "Nom",
    "title": "Titre",
    "type": "Catégorie",
    "status": "Statut",
    "date": "Date",
    "done": "Terminé",
    "direction": "Sens",
    "subject": "Sujet",
    "delivery": "Livraison",
    "quoteNumber": "Devis n°",
    "approval": "Approbation",
    "total": "Total",
    "expiry": "Expiration",
    "industry": "Secteur",
    "phone": "Téléphone",
    "mobile": "Mobile",
    "jobTitle": "Poste",
    "department": "Service",
    "consent": "Consentement",
    "contact": "Contact",
    "primary": "principal",
    "firstName": "Prénom",
    "lastName": "Nom",
    "whatsapp": "WhatsApp",
    "secondaryPhone": "Téléphone secondaire",
    "preferredLanguage": "Langue préférée",
    "consentStatus": "Statut du consentement",
    "emergencyContact": "Contact d'urgence",
    "emergencyPhone": "Téléphone d'urgence",
    "primaryContact": "Contact principal",
    "communicationPreferencesJson": "Préférences de communication JSON",
    "socialProfilesJson": "Profils sociaux JSON",
    "notes": "Notes",
    "assignedEmployee": "Employé assigné",
    "country": "Pays",
    "currency": "Devise",
    "actions": "Opérations",
    "accountName": "Nom du compte",
    "parentAccountId": "ID du compte parent",
    "accountType": "Type de compte",
    "accountStatus": "Statut du compte",
    "website": "Site web",
    "annualRevenue": "Chiffre d'affaires annuel",
    "employeeCount": "Nombre d'employés",
    "ownership": "Propriété",
    "companySize": "Taille de l'entreprise",
    "branchCode": "Code de succursale",
    "taxNumber": "Numéro fiscal",
    "taxRegistrationType": "Type d'immatriculation fiscale",
    "language": "Langue",
    "timeZone": "Fuseau horaire",
    "billingAddress": "Adresse de facturation",
    "billingCity": "Ville de facturation",
    "billingState": "Région de facturation",
    "billingCountry": "Pays de facturation",
    "billingPostalCode": "Code postal de facturation",
    "shippingAddress": "Adresse de livraison",
    "shippingCity": "Ville de livraison",
    "shippingState": "Région de livraison",
    "shippingCountry": "Pays de livraison",
    "shippingPostalCode": "Code postal de livraison",
    "branchAccount": "Compte succursale",
    "description": "Descriptif",
    "profile": "Profil",
    "openDeals": "Affaires ouvertes",
    "openTickets": "Tickets ouverts",
    "activities": "Activités",
    "invoices": "Factures",
    "quotes": "Devis",
    "wonRevenue": "Revenu gagné",
    "searchTimeline": "Rechercher dans la chronologie",
    "activityType": "Type d'activité",
    "newActivity": "Nouvelle activité",
    "timeline": "Chronologie",
    "slaDue": "SLA dû le {{date}}",
    "financeQuotes": "Finance — Devis",
    "financeInvoices": "Finance — Factures",
    "deskTickets": "Tickets support",
    "closedStatus": "(fermé)",
    "openStatus": "(ouvert)",
    "contacts": "Contacts",
    "primaryStatus": "(principal)",
    "deals": "Affaires",
    "crmDocuments": "Documents CRM",
    "fileId": "ID fichier",
    "communicationCenter": "Centre de communication",
    "message": "Message"
  },
  "formActions": {
    "convertToDeal": "Convertir en affaire",
    "convert": "Convertir",
    "importCsv": "Importer CSV",
    "createCampaign": "Créer une campagne",
    "launch": "Lancer",
    "schedule": "Planifier",
    "addContact": "Ajouter un contact",
    "createContact": "Créer un contact",
    "checkDuplicates": "Vérifier les doublons",
    "mergeCurrentIntoThis": "Fusionner l'actuel dans celui-ci",
    "addDeal": "Ajouter une affaire",
    "createDeal": "Créer une affaire",
    "createQuote": "Créer un devis",
    "submit": "Soumettre",
    "approve": "Approuver",
    "pdf": "PDF",
    "share": "Partager",
    "addCompany": "Ajouter une société",
    "edit": "Modifier",
    "delete": "Supprimer",
    "createAccount": "Créer un compte",
    "editAccount": "Modifier le compte",
    "saveChanges": "Enregistrer les modifications",
    "addActivity": "Ajouter une activité",
    "addDocument": "Ajouter un document",
    "record": "Enregistrer"
  },
  "listActions": {
    "newLead": "Nouveau prospect",
    "deleteAccountConfirm": "Supprimer le compte {{name}} ?",
    "deleteContactConfirm": "Supprimer le contact {{name}} ?",
    "openCustomerSupport360": "Ouvrir le Support client 360 →"
  },
  "empty": {
    "noActivitiesYet": "Aucune activité pour le moment",
    "noQuotes": "Aucun devis",
    "noFinanceInvoices": "Aucune facture finance",
    "noTickets": "Aucun ticket",
    "noContacts": "Aucun contact",
    "noDeals": "Aucune affaire",
    "noCrmDocuments": "Aucun document CRM",
    "noSubject": "Aucun sujet",
    "noCommunications": "Aucune communication"
  },
  "segments": {
    "allCustomers": "Tous les clients",
    "webFormLeads": "Prospects du formulaire web",
    "facebookInboxLeads": "Prospects de la boîte Facebook"
  },
  "defaults": {
    "dealFromLead": "Affaire depuis le prospect n°{{id}}"
  }
}
